import { FC } from 'react';
import LazyLoad from 'react-lazyload';
import { useTranslation } from 'react-i18next';

import styles from './Supporters.module.scss';

const LAZY_LOAD_OFFSET = 200;

export const Supporters: FC = () => {
  const { t } = useTranslation('marketingPages');
  return (
    <div className={styles.container} data-test-id="supporters-section">
      {/* The word Supporters is intentionally English, regardless of EN / JA by Hayato */}
      <h2 className={styles.title}>Supporters</h2>
      <div className={styles.images}>
        <LazyLoad once={true} offset={LAZY_LOAD_OFFSET}>
          <img
            alt={t('seo.landingPage.supporters.smbc')}
            height={16}
            src="/static/images/shareholders-logo/smbc.png"
            width={182}
          />
        </LazyLoad>
        <LazyLoad once={true} offset={LAZY_LOAD_OFFSET}>
          <img
            alt={t('seo.landingPage.supporters.mizuho')}
            height={41}
            src="/static/images/shareholders-logo/mizuho.png"
            width={182}
          />
        </LazyLoad>
        <LazyLoad once={true} offset={LAZY_LOAD_OFFSET}>
          <img
            alt={t('seo.landingPage.supporters.mitsubishi')}
            height={55}
            src="/static/images/shareholders-logo/mitsubishi.png"
            width={182}
          />
        </LazyLoad>
        <LazyLoad once={true} offset={LAZY_LOAD_OFFSET}>
          <img
            alt={t('seo.landingPage.supporters.persol')}
            height={53}
            src="/static/images/shareholders-logo/persol.png"
            width={182}
          />
        </LazyLoad>
      </div>
    </div>
  );
};

export default Supporters;
